<template>
  <v-container fluid>
    <v-row>
        <v-col>

          <v-card-title>
            <h1 class="headline mb-1">Flujos</h1>
            <v-spacer></v-spacer>
            <v-btn dark class="mr-4" color="info" 
              :to="{'name': 'expediente_flujo_opt', params: {'opt': 'crear'}}">
              <v-icon color="lighten-1">mdi-plus</v-icon>
              Crear flujo
            </v-btn>
          </v-card-title>
          <DataTableSimpleFlujos opt="drafts">
          </DataTableSimpleFlujos>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTableSimpleFlujos from '@/views/Admin/DataTableSimpleFlujos.vue'; 
export default {
  components: { DataTableSimpleFlujos },
  data: function() {
    return {
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {

  },
  mounted() {

  },
  methods: {

  },
};
</script>